export enum ViewStates {
  Combined,
  Calendar,
  Table,
  Saldo,
  None,
}
